import { Autocomplete, Button, DialogContent, DialogTitle, ListItem, TextField, Typography } from "@mui/material";
import { useState } from "react";
import DialogButtons from "@entrilia/shared/components/DialogButtons";
import DialogCloseButton from "@entrilia/shared/components/DialogCloseButton";
import ListWithLazyRender from "@entrilia/shared/components/ListWithLazyRender";
import SmallDialog from "@entrilia/shared/components/SmallDialog";
import type { LookupObjectReference } from "../../../../api/types/objectTypes";

interface Props {
  companyOptions: LookupObjectReference[];
  onClose: () => void;
  onAdd: (companyIds: string[]) => void;
}

const AddCompaniesDialog = ({ companyOptions, onClose, onAdd }: Props) => {
  const [selectedCompanyIds, setSelectedCompanyIds] = useState<string[]>([]);

  const handleAdd = () => {
    onAdd(selectedCompanyIds);
    onClose();
  };

  return (
    <SmallDialog open onClose={onClose}>
      <DialogTitle>Add Companies</DialogTitle>
      <DialogCloseButton onClick={onClose} />

      <DialogContent>
        <Autocomplete
          multiple
          fullWidth
          options={companyOptions}
          getOptionLabel={(o) => o.primaryFieldValue}
          onChange={(_, items) => items && setSelectedCompanyIds(items.map((i) => i.objectId))}
          renderInput={(inputProps) => <TextField {...inputProps} autoFocus placeholder="Type company name..." />}
          renderOption={({ key: _key, ...props }, option) => (
            <ListItem key={option.objectId} {...props}>
              <Typography>{option.primaryFieldValue}</Typography>
            </ListItem>
          )}
          slotProps={{ listbox: { component: ListWithLazyRender } }}
        />
      </DialogContent>

      <DialogButtons onCancel={onClose}>
        <Button variant="contained" onClick={handleAdd} disabled={selectedCompanyIds.length === 0}>
          Add
        </Button>
      </DialogButtons>
    </SmallDialog>
  );
};

export default AddCompaniesDialog;
